import {
  DList,
  DListResponse,
  DObjectResponse,
  TriggerTypes,
} from 'models/common.model';

export type EvaluationCriterias = {
  id: number;
  customerFeedbackId: number;
  feedbackEvaluationCriteriaId: number;
  feedbackEvaluationCriteriaName: string;
  starNumber: number;
  feedbackEvaluationCriteriaAnswerId?: number | null;
  feedbackEvaluationCriteriaAnswerName?: string | null;
};

export enum CriterialType {
  RANKING = 1,
  QUESTION = 2,
}

export type EvaluationFeedbackCriteriaModel = {
  id: number;
  code: string;
  name: string;
  orderNo: number;
  type: number;
  isActive: boolean;
  localizations: LocalizationModel[];
  answers: AnswerModel[];
  createdByName: string;
  createdTime: Date | null | undefined;
};

export type GetEvaluationFeedbackCriteriaRequestModel = {
  id?: number;
};

export type GetEvaluationFeedbackCriteriaResponseModel =
  DObjectResponse<EvaluationFeedbackCriteriaModel>;

export type ListEvaluationFeedbackCriteriaRequestModel = {
  pageIndex?: number;
  pageSize?: number;
  name?: string;
  type?: number;
  isActive?: boolean | null;
};

export type ListEvaluationFeedbackCriteriaResponseModel =
  DListResponse<EvaluationFeedbackCriteriaModel>;

export type AnswerModel = {
  name: string;
  orderNo: 0;
};

export type LocalizationModel = {
  id: number;
  typeId: string;
  dataId: number;
  languageId: number;
  name: string;
};

export type SaveEvaluationFeedbackCriteriaRequestModel = {
  id?: number;
  code?: string;
  name: string;
  orderNo: number;
  type: string;
  answers: AnswerModel[];
  localizations: LocalizationModel[];
};

export type SaveEvaluationFeedbackCriteriaResponseModel =
  DObjectResponse<boolean>;

export type DeleteEvaluationFeedbackCriteriaRequestModel = {
  id?: number;
};

export type DeleteEvaluationFeedbackCriteriaResponseModel =
  DObjectResponse<boolean>;

export type ActiveEvaluationFeedbackCriteriaRequestModel = {
  id?: number;
  reason: string;
};

export type ActiveEvaluationFeedbackCriteriaResponseModel =
  DObjectResponse<boolean>;

export type InactiveEvaluationFeedbackCriteriaRequestModel = {
  id?: number;
  reason: string;
};
export type InactiveEvaluationFeedbackCriteriaResponseModel =
  DObjectResponse<boolean>;

export interface EvaluationFeedbackCriteriaStateModel {
  evaluationFeedbackCriteriaListData: DList<EvaluationFeedbackCriteriaModel> | null;
  evaluationFeedbackCriteriaDetail: EvaluationFeedbackCriteriaModel | null;
  triggerSaveEvaluationFeedbackCriteria: TriggerTypes | null;

  loadingList: boolean;
  loadingDetail: boolean;
}
